import { Box } from '@mui/material';
import React from 'react';

const Logo = ({ size, className }: { size?: number; className?: string }) => {
  const style = { width: size || '100%', height: 'auto' };
  return (
    <Box sx={style}>
      <img src={`/logo-outline-128.png`} alt="Logo" className={className} />
    </Box>
  );
};

export const JotPsychWordmarkLogo = ({
  size,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  const style = { width: size || '100%', height: 'auto' };
  return <img src={`/jotpsych-logo.png`} alt="JotPsych" style={style} className={className} />;
};

export default Logo;
